<template>
  <el-table-column
    :key="code"
    :label="name"
    :fixed="false"
    align="center"
    width="300"
  >
    <template #default="scope">
      <el-tag v-for="label in parseData(scope.row[code])" :key="label.id" size="mini" type="primary">
        {{ label.name }}
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    // 标签数据类型 json | ids
    labelDataType: {
      type: String,
      default: 'json'
    }
  },
  methods: {
    /**
     * 解析数据
     * @param data
     * @returns {any|*[]}
     */
    parseData(data) {
      switch (this.labelDataType) {
        case 'json':
          return this.parseJson(data)
        case "ids":
          return this.parseIds(data)
        default:
          return data
      }
    },
    /**
     * 格式化json类型数据
     * @param data
     * @returns {any|*[]}
     */
    parseJson(data) {
      try {
        return JSON.parse(data)
      } catch (err) {
        return []
      }
    },
    /**
     * 格式化id字符串类型数据
     * @param data
     * @returns {*[]}
     */
    parseIds(data) {
      if (typeof data === 'string') {
        const idList = data.split(",").filter(item => item.length > 0)
        return idList.map(item => {
          const info = this.$store.getters.getLabelInfo(item)
          if (info !== null && info !== undefined) {
            return info
          } else {
            return {
              id: item,
              name: item,
              code: item
            }
          }
        })
      } else {
        return []
      }
    }
  }
}
</script>
